import { useContext } from 'react';
import SideNavigationContext from './SideNavigationContext';

export const useSideNavigationContext = () => useContext(SideNavigationContext);
